type SignOutConfirmModalProps = {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  cancelLabel: string;
  confirmLabel: string;
};

export default function SignOutConfirmModal({
  open,
  onCancel,
  onConfirm,
  title,
  message,
  cancelLabel,
  confirmLabel,
}: SignOutConfirmModalProps) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ background: "var(--modal-backdrop)" }}
    >
      <div className="w-full max-w-sm rounded-2xl border border-[color:var(--field-border)] bg-[color:var(--surface)] p-6 shadow-[var(--modal-shadow)]">
        <h3 className="text-lg font-semibold text-[color:var(--foreground)]">{title}</h3>
        <p className="mt-2 text-sm text-[color:var(--muted)]">{message}</p>
        <div className="mt-5 flex justify-end gap-2">
          <button
            type="button"
            data-tab-trigger="true"
            onClick={onCancel}
            className="rounded-full border border-[color:var(--field-border)] bg-[color:var(--surface)] px-4 py-2 text-xs font-semibold uppercase tracking-widest text-[color:var(--foreground)] transition hover:bg-[color:var(--surface-hover)]"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            data-tab-trigger="true"
            onClick={onConfirm}
            className="rounded-full bg-[color:var(--accent)] px-4 py-2 text-xs font-semibold uppercase tracking-widest text-white transition hover:brightness-110"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
